
if (!customElements.get('card-product-info')) {
  customElements.define(
    'card-product-info',
    class CardProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        const scriptTag = this.querySelector("script[data-selected-variant]");
        if(scriptTag) { 
          const currentVariantData = JSON.parse(scriptTag.textContent.trim());
          console.log(currentVariantData);
        }
      }

      connectedCallback() {
          console.log(`card-product-info connected for product ID: ${this.id}`);

          this.initializeProductSwapUtility();
          this.onVariantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.optionValueSelectionChange,
            ({ data: { event, target, selectedOptionValues } }) => {
              // Extract product ID from the clicked input's `id`
              const targetProductId = target.id.split("-")[0]; // Get first part before "-
              // Extract product ID from this `card-product-info` instance
              const parentProductId = this.id.replace("MainCardProduct-", "");
  
              // Ensure only the correct product instance processes the event
              if (targetProductId !== parentProductId) {
                return;
              }

              console.log(`Processing event in correct instance: ${parentProductId}`);
              this.handleOptionValueChange({ data: { event, target, selectedOptionValues } });
            }
          );

          this.initQuantityHandlers();
          this.dispatchEvent(new CustomEvent('card-product-info:loaded', { bubbles: true }));
        }


      addPreProcessCallback(callback) {
        console.log("------ add preprocess callback---------");
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        console.log("------ init quantity handlers ---------");
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        console.log("------ disconnected callback---------");
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        console.log("------  initilize product swap utlility---------");
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        console.log("-----------------------init handle option value change----------------------------");

        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        const collectionUrl = '/collections/cones';



        this.renderProductInfo({
          collectionUrl: collectionUrl,
          productUrl: productUrl,
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, collectionUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl, collectionUrl),
        });
      }

      resetProductFormState() {
        console.log("------ reset product form state---------");
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, collectionUrl, updateFullPage) {
        console.log("-----------------------handle swap product-----------------------")
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "card-product-info[id^='MainCardProduct']" : 'card-roduct-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('card-product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ collectionUrl, productUrl, requestUrl, targetId, callback }) {
        console.log("-----------------------render product info-----------------------");
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }






      getSelectedVariant(productInfoNode, productUrl) {
        console.log("-----------------------get selected variant----------------------- ");
        console.log(productInfoNode);
        console.log(productUrl);
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        console.log(selectedVariant);
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;

      }









      buildRequestUrlWithParams(productUrl, optionValues, shouldFetchFullPage = false) {
        console.log("-----------------------  build request url----------------------- ");
        const params = [];

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${productUrl}?${params.join('&')}`;
      }

      updateOptionValues(html, productUrl) {
        const newVariantSelects = html.querySelector('variant-selects');
        const oldVariantSelects = this.variantSelectors;

        console.log('old  :', oldVariantSelects);
        console.log('new : ', newVariantSelects);



        const oldScript = oldVariantSelects.querySelector("script[data-selected-variant]");
        const newScript = newVariantSelects.querySelector("script[data-selected-variant]");

        if (oldScript && newScript) {
          oldScript.replaceWith(newScript.cloneNode(true));
          console.log("Replaced script tag with updated variant data.");
        } else {
          console.warn("No script tag found for replacement.");
        }

        Array.from(newVariantSelects.querySelectorAll("input[type=radio]"))
        .forEach((newInput, index) => {
            Array.from(oldVariantSelects.querySelectorAll("input[type=radio]"))
            .forEach((oldInput) => {
              if(newInput.getAttribute('data-option-value-id') == oldInput.getAttribute('data-option-value-id')) {
                if(newInput.classList.contains('disabled')) {
                  oldInput.classList.add("disabled");
                } else {
                  oldInput.classList.remove("disabled");
                }
              }
            });
        });






      }


      handleUpdateProductInfo(productUrl, collectionUrl) {
        console.log("-----------------------handle product info----------------------- ");
        return (html) => {
          const variant = this.getSelectedVariant(html, productUrl);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html, productUrl);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);



          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {


            console.log("-----------------------update source from dest-----------------------");

            const source = html.querySelector(`product-info[data-url='${productUrl}'] .price`);

            const destination = this.querySelector('.card-information .price');

            console.log(source);
            console.log(destination);

            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
          };

          updateSourceFromDestination();


          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );


          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              productUrl: this.dataset.url,
              sectionId: this.sectionId,
              html: matchingProduct,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        console.log("------------update vairant inputs------------");
        console.log(variantId);
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        /*this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);*/
      }

      setUnavailable() {
        console.log("------ set unavailable---------");
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const oldMedia = this.querySelector('.card__media .media img');
        const newMedia = html.querySelector(`media-gallery ul li:first-child img`);

        if(oldMedia && newMedia) {
        oldMedia.replaceWith(newMedia.cloneNode(true));
        } else {
          return;
        }



      }

      setQuantityBoundries() {
        console.log("------set quantityt boundaries---------");
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        console.log("fetch quanitty rules");
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        console.log("update quantity rules");


        const scriptTag = this.querySelector("script[data-selected-variant]");

        if(scriptTag) { 
          const variantData = JSON.parse(scriptTag.textContent.trim());
          console.log(variantData);
        }



        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);


        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        console.log("~~ get productForm ~~");
        return this.querySelector(`card-product-form`);
      }

      get productModal() {
        console.log("~~ get product modal ~~");
        return document.querySelector(`#CardProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        console.log("~~ get pickupAvailability ~~");
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        console.log("~~ get variantSelectors ~~");
        console.log(this);
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        console.log("~~ get related products ~~");
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        console.log("~~ get quickOrderList ~~");
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        console.log("~~ get sectionid ~~");
        console.log(this);
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
